 import React, { memo } from 'react'
import styles from './CategoryItem.module.scss'
import { ProductCategory } from '../../../../model/appliance'

type AddingProps = {
    isSelected: boolean
    onAddAppliance: (category: ProductCategory) => void
    onRemoveAppliance: (category: ProductCategory) => void
}

type EditingProps = {
    category: ProductCategory
    onEditAppliance: (category: ProductCategory) => void
}

type Props = {
    category: ProductCategory
    isAdded: boolean
    addingProps?: AddingProps
    editingProps?: EditingProps
    onEditApplianceHandler?: () => void
    onDeleteApplianceHandler?: () => void
}

const ProductCategoryItem: React.FC<Props> = memo((props: Props) => {
    const { category, isAdded, addingProps, editingProps } = props
   
    function onChange() {
        if (addingProps!.isSelected) {
            addingProps!.onRemoveAppliance(category)
        } else {
            addingProps!.onAddAppliance(category)
        }
    }

    function onEdit() {
        // editingProps!.onEditAppliance({
        //     ...editingProps!.category, editingProps: {
        //         ...editingProps!.category.editingProps,
        //         editing: true,
        //         newAppliance: category
        //     }
        // })
    }

    return (
        <div className={styles.searchResultItem}>
            <div className={styles.searchResultItemInfo}>
                <div className={styles.division}>
                    <img src={category.imageUrl} alt={category.name} />
                    {category.name}
                </div>
                {
                    addingProps && <>
                        {
                            !isAdded ? <button className={`standardButton ${styles.button} ${addingProps!.isSelected && styles.removeButton}`} onClick={onChange} >
                                {addingProps!.isSelected ? 'Remove' : 'Add'}
                            </button> : <div className={`standardButton ${styles.button} ${styles.addedButton}`}>Added</div>
                        }
                    </>
                }
                {
                    editingProps && <>
                        {
                            !isAdded ? <button className={`standardButton ${styles.button}`} onClick={onEdit}>Change</button>
                                : <div className={`standardButton ${styles.button} ${styles.addedButton}`}>Added</div>
                        }
                    </>
                }
                {
                    (props.onEditApplianceHandler || props.onDeleteApplianceHandler) && <div className={styles.division}>
                        {
                            props.onEditApplianceHandler &&
                            <button className={`standardButton ${styles.submitButton}`} onClick={props.onEditApplianceHandler}>
                                Edit
                            </button>
                        }
                        {
                            props.onDeleteApplianceHandler &&
                            <button className={`standardButton ${styles.submitButton}`} onClick={props.onDeleteApplianceHandler}>
                                Delete
                            </button>
                        }
                    </div>
                }

            </div>
        </div>
    )
})

export default ProductCategoryItem